import * as AuthConstants from '../actions/AuthConstants';
import { AuthState } from '../actions/AuthTypes';
import { getTokenValue } from '../globals/auth';

const jwtToken = getTokenValue();

export default (state = AuthConstants.DEFAULT_STATE, action: any): AuthState => {
  switch (action.type) {
    case AuthConstants.AuthActionTypes.SIGNED_IN:
      return {
        ...state,
        is_logged_in: true,
        reconnect: false,
        access_token: action.payload.access_token,
      };
    case AuthConstants.AuthActionTypes.SIGN_IN_ERROR:
      return { ...state, error_message: action.response };
    case AuthConstants.AuthActionTypes.SIGNED_OUT:
      return { ...state, is_logged_in: false, access_token: '' };
    case AuthConstants.AuthActionTypes.RECONNECTING:
      return { ...state, reconnect: true, access_token: '' };
    default:
      if (jwtToken) {
        return { ...state, is_logged_in: true, access_token: jwtToken };
      } else {
        return state;
      }
  }
};
